import { DocumentReference } from '@firebase/firestore';
import { CompanyType, InventoryClass } from '../enums';
import { AssociatedCompany, Model, Nullable } from '../types';
import { OrderFilesPermissions } from './OrderFilesPermissions';

export class Company implements Model {
  id!: string;
  accountNumber?: string;
  allowPartialCuts = false;
  associatedCompanies: Nullable<Record<string, AssociatedCompany>> = null;
  associatedCompaniesCount = 0;
  canSeeCSA = false;
  canSeeUL = false;
  class?: string = InventoryClass.ClassA;
  code: Nullable<string> = null;
  codeNormalized: Nullable<string> = null;
  employeeCount?: number = 0;
  employeeRefs: DocumentReference[] = [];
  hasCustomPartNumbers = false;
  isDeleted = false;
  name!: string;
  nameNormalized?: string = '';
  orderFilesPermissions!: CompanyOrderFilePermission;
  salesRepIds: Nullable<string[]> = null;
  salesRepIdsNormalized: Nullable<string[]> = null;
  shippingDocEmailRecipient: Nullable<string[]> = null;
  type!: CompanyType;

  constructor(type: CompanyType) {
    this.type = type;
  }
}

export class CompanyOrderFilePermission {
  buyer!: OrderFilesPermissions;
  general!: OrderFilesPermissions;
  sales!: OrderFilesPermissions;
}
